import { Grid, Typography } from '@mui/material';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { TooltipProps } from 'recharts/types/component/Tooltip';
import { GenericInfoLabel } from 'src/v2/components/ui/label';

import { primaryColors } from '~components/theme/styles/colors';
import { EDisplayType } from '~components/types';
import { displayFormatUnits } from '~components/utils/utils';

import { GraphToolTip } from '../graphToolTip';

export const TvlAreaGraphTooltip = ({ active, payload }: TooltipProps<ValueType, NameType>) => {
  return (
    <GraphToolTip active={active} payload={payload}>
      <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="label3" color={primaryColors[700]}>
          VESTA TVL
        </Typography>
        <GenericInfoLabel
          labelTitle={displayFormatUnits({
            value: payload?.[0]?.payload?.tvl,
            displayType: EDisplayType.USD,
          })}
          sx={{
            width: 'fit-content',
          }}
        />
      </Grid>
    </GraphToolTip>
  );
};
